/**
 * Crisis / emergency information — the single source for every crisis
 * notice on the site (footer, contact and request-a-call forms, checkout,
 * Resources card, policy text). Change numbers here only.
 *
 * Owner decision D11: the owner must confirm every number before it is
 * published. Her November 2026 corrections: emergency "911 or 919", and the
 * National Hotline for Crisis Intervention (242) 322-2763. Her Bahamas
 * Crisis Center lines (24-hour hotline and WhatsApp) are on the Resources
 * page, from the content seed. Components hide the hotline if it is blank.
 */

export const CRISIS = {
  region: "The Bahamas",

  // Displayed in this order: "call 911 or 919".
  emergencyNumbers: ["911", "919"],

  // Owner-supplied crisis hotline. A blank number is not rendered.
  //
  // Her list also had an "International Crisis Text Line" entry (text HOME
  // to Crisis Text Line's US short code). It is left out on purpose: Crisis
  // Text Line does not serve The Bahamas (its own "Where We Are" page lists
  // only the US, UK, Canada and Ireland). Do not add it here or on the
  // Resources page; a test fails if the short code appears anywhere in src.
  hotline: {
    name: "National Hotline for Crisis Intervention",
    number: "(242) 322-2763",
    hours: "24 hours, all islands",
  },

  // Footer / general one-liner. {hotline} is the hotline sentence, or
  // nothing when the number is blank.
  notice:
    "Healing Hues is not an emergency service. If you are in crisis or at risk of harm, call {numbers} (emergency services in {region}) or go to the nearest hospital emergency department.{hotline}",

  // Under forms that are not monitored in real time (contact, checkout).
  formNote:
    "This form is not monitored for emergencies. If you need urgent help, call {numbers} or go to the nearest hospital emergency department.{hotline}",

  // Filled into {hotline}; {name} and {number} come from `hotline`.
  hotlineSentence: " You can also call the {name} at {number}.",
};

/** "911 or 919" */
export function formatEmergencyNumbers(numbers = CRISIS.emergencyNumbers) {
  if (numbers.length <= 1) return numbers.join("");
  return `${numbers.slice(0, -1).join(", ")} or ${numbers[numbers.length - 1]}`;
}

/** True once the owner has filled in a hotline number. */
export function hasHotline(crisis = CRISIS) {
  return Boolean(crisis.hotline && String(crisis.hotline.number).trim());
}

/** Plain-text versions (for policy copy, emails, etc.). */
export function crisisNoticeText(template = CRISIS.notice) {
  const hotline = hasHotline()
    ? CRISIS.hotlineSentence.replace("{name}", CRISIS.hotline.name).replace("{number}", CRISIS.hotline.number)
    : "";
  return template
    .replace("{numbers}", formatEmergencyNumbers())
    .replace("{region}", CRISIS.region)
    .replace("{hotline}", hotline);
}
